// test204
(204 && 0);
